// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/modern/" + {"234":"index-page","241":"info-page","328":"focus-visible","858":"catalog-page"}[chunkId] + "." + {"234":"936d4b22","241":"183a17cd","328":"6ee8c859","858":"92bc241a"}[chunkId] + ".js";
};